import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateHTML',
  standalone: true
})
export class TruncateHTMLPipe implements PipeTransform {

  transform(value: string, limit: number): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = value;
    const text = tempDiv.textContent || tempDiv.innerText || '';
    return text.length > limit ? text.substring(0, limit) + '...' : text;
  }
}
